import {
  IInstrumentStatistic,
  IStepOrderBookFundInfo,
} from "../../Interfaces/stepInterfaces";
import { addSeperatorToInput } from "../../helper";

interface IStepOrderBookInfoProps {
  instrumentStatistic?: IInstrumentStatistic;
  fundInfo?: IStepOrderBookFundInfo;
  onPriceClick?: (price?: number) => void;
}

const StepOrderBookInfo = ({
  fundInfo,
  instrumentStatistic,
  onPriceClick,
}: IStepOrderBookInfoProps) => {
  const getInstrumentStatisticPercentClassname = (v?: number) => {
    if (!v) return "";
    if (Math.sign(v) < 0) return "text-red-700 ltr";
    if (Math.sign(v) > 0) return "text-green-600 ltr";
    return "";
  };

  return (
    <div className="text-xs border-2 border-gray-300 rounded p-2 flex flex-col justify-start items-start gap-2 min-h-[141px] w-40">
      <div className="flex flex-row justify-between w-full">
        <div>معامله:</div>
        <div className="flex flex-row justify-start gap-2">
          <div
            className="cursor-pointer hover:text-blue-600"
            onClick={() => onPriceClick?.(instrumentStatistic?.trade?.price)}
          >
            {addSeperatorToInput(instrumentStatistic?.trade?.price, "price")}
          </div>
          {instrumentStatistic?.trade?.percent &&
          instrumentStatistic?.trade?.percent !== 0 ? (
            <div
              className={getInstrumentStatisticPercentClassname(
                instrumentStatistic?.trade?.percent
              )}
            >
              [{instrumentStatistic?.trade?.percent}]
            </div>
          ) : null}
        </div>
      </div>
      <div className="flex flex-row justify-between w-full">
        <div>پایانی:</div>
        <div className="flex flex-row justify-start gap-2">
          <div
            className="cursor-pointer hover:text-blue-600"
            onClick={() => onPriceClick?.(instrumentStatistic?.final?.price)}
          >
            {addSeperatorToInput(instrumentStatistic?.final?.price, "price")}
          </div>
          {instrumentStatistic?.final?.percent &&
          instrumentStatistic?.final?.percent !== 0 ? (
            <div
              className={getInstrumentStatisticPercentClassname(
                instrumentStatistic?.final?.percent
              )}
            >
              [{instrumentStatistic?.final?.percent}]
            </div>
          ) : null}
        </div>
      </div>
      {instrumentStatistic?.margin ? (
        <div className="flex flex-row justify-between w-full">
          <div>وجه تضمین:</div>
          <div>{addSeperatorToInput(instrumentStatistic.margin, "price")}</div>
        </div>
      ) : null}
      {instrumentStatistic?.status ? (
        <div className="flex flex-row justify-between w-full">
          <div>وضعیت:</div>
          <div>{instrumentStatistic.status}</div>
        </div>
      ) : null}
      {instrumentStatistic?.minPricePermit || instrumentStatistic?.maxPricePermit ? (
        <div className="flex flex-row justify-between w-full">
          <div>قیمت مجاز:</div>
          <div className="flex flex-row justify-start gap-1">
            <div
              className="cursor-pointer hover:text-blue-600"
              onClick={() => onPriceClick?.(instrumentStatistic?.minPricePermit)}
            >
              {addSeperatorToInput(instrumentStatistic?.minPricePermit, "price")}
            </div>
            <div>-</div>
            <div
              className="cursor-pointer hover:text-blue-600"
              onClick={() => onPriceClick?.(instrumentStatistic?.maxPricePermit)}
            >
              {addSeperatorToInput(instrumentStatistic?.maxPricePermit, "price")}
            </div>
          </div>
        </div>
      ) : null}
      {fundInfo?.nav ? (
        <div className="flex flex-row justify-between w-full">
          <div>NAV:</div>
          <div>{addSeperatorToInput(fundInfo?.nav, "price")}</div>
        </div>
      ) : null}
      {fundInfo?.purchaseBubble ? (
        <div className="flex flex-row justify-between w-full">
          <div>حباب خرید NAV:</div>
          <div>{fundInfo?.purchaseBubble}%</div>
        </div>
      ) : null}
      {fundInfo?.sellBubble ? (
        <div className="flex flex-row justify-between w-full">
          <div>حباب فروش NAV:</div>
          <div>{fundInfo?.sellBubble}%</div>
        </div>
      ) : null}
    </div>
  );
};

export default StepOrderBookInfo;
